/** Available types of month for absolute deadlines */
export enum DeadlineMonthTypeEnum {
  /** Current month at the time of using the entity with a deadline */
  CURRENT = 'CURRENT',
  /** Next month at the time of using the entity with a deadline */
  NEXT = 'NEXT',
}
